module.exports = __webpack_public_path__ + "img/wallet-fill.d41c8f6e.svg";